module.exports = __webpack_public_path__ + "img/gifCompare.2dc3a58a.gif";